var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotels-grid"},_vm._l((_vm.hotels),function(hotel,idx){return _c('HotelCard',{key:idx,attrs:{"hotel":hotel}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }